import {
  ColumnMetadata,
  LocalColumnConfig,
} from 'app/modules/localTableSettings/models';

export const buildReconciledColumns = (
  columns: ColumnMetadata[],
  visibleKeys: string[],
): LocalColumnConfig[] => {
  const visibleSet = new Set(visibleKeys);
  const columnsByKey = new Map(columns.map((c) => [c.key, c]));

  const visible = visibleKeys.flatMap<LocalColumnConfig>((key) => {
    const column = columnsByKey.get(key);
    return column ? [{ ...column, hidden: false }] : [];
  });

  const hidden = columns
    .filter((c) => !visibleSet.has(c.key))
    .map<LocalColumnConfig>((c) => ({ ...c, hidden: true }))
    .toSorted((a, b) =>
      a.label.toLowerCase().localeCompare(b.label.toLowerCase()),
    );

  return [...visible, ...hidden];
};
